var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFingerprinting = function SvgFingerprinting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6E6E6E",
    fillRule: "evenodd",
    d: "M6.5 2a4.5 4.5 0 0 1 4.473 4c.03.275-.197.5-.473.5s-.496-.225-.535-.499A3.5 3.5 0 0 0 3 6.5c0 1.758.604 3.373 1.616 4.652a.527.527 0 0 1-.047.717.48.48 0 0 1-.695-.045A8.47 8.47 0 0 1 2 6.5 4.5 4.5 0 0 1 6.5 2m0 2A2.5 2.5 0 0 1 9 6.5a1.5 1.5 0 0 0 1.01 1.418c.26.09.49.306.49.582s-.226.505-.497.45A2.5 2.5 0 0 1 8 6.5a1.5 1.5 0 1 0-3 0c0 1.89.952 3.556 2.405 4.547a.54.54 0 0 1 .182.7.47.47 0 0 1-.67.177A6.5 6.5 0 0 1 4 6.5 2.5 2.5 0 0 1 6.5 4m0-3A5.5 5.5 0 0 0 1 6.5c0 1.718.456 3.329 1.253 4.719a.52.52 0 0 1-.16.698.48.48 0 0 1-.681-.155A10.45 10.45 0 0 1 0 6.5a6.5 6.5 0 0 1 11.92-3.589.47.47 0 0 1-.176.67.54.54 0 0 1-.7-.18A5.5 5.5 0 0 0 6.5 1m4 9.5c0 .276-.225.503-.5.473a4.5 4.5 0 0 1-3.973-3.974c-.03-.274.197-.499.473-.499s.496.225.535.499a3.5 3.5 0 0 0 2.967 2.966c.273.039.498.259.498.535",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgFingerprinting;